import React from "react";
// import Home from "./home/Home";
import Home from "./home";
import HospitalList from "./hospital/index";
import HospitalDetails from "./hospital/details";
import PackDetails from "./package/details";
import AddressMap from "../components/addressmap";
import PacksList from "./package/index";
import Custom from "./package/custom";
import AddCalendar from "../components/addcalendar";
import { Callback } from "../components/auth/callback";
import { Logout } from "../components/auth/logout";
import { LogoutCallback } from "../components/auth/logoutCallback";
import { SilentRenew } from "../components/auth/silentRenew";
import { PublicPage } from "../components/publicPage";
import { PrivatePage } from "../components/privatePage";
import NewList from "./new/index";
import NewDetails from "./new/details";
import CartList from "./shopping/index";
import AddCart from "./shopping/addcart";
import SAccount from "./shopping/account";
import Members from "./members/index";
import OrderList from './members/order/index';
import Integral from './members/integral/index';
import Consume from './members/integral/consume';
import IntegralDetail from './members/integral/detail';
import IntegralSysm from './members/integral/sysm';
import IntegralSyfw from './members/integral/syfw';
import IntegralJqsm from './members/integral/jqsm';
import PeopleList from './members/people/index';
import AddressList from './members/address/index';
import Editmobile from './members/integral/editmobile';
import ForgetPSW from './members/integral/forgetPSW';
import Pay from './common/pay';
import OrdermentList from './members/orderment/index';
import Addorderment from './members/orderment/addorderment';
import PackageList from './members/orderment/packagelist';
import QueryReport from './members/report/queryreport';
import QueryReportDetail from './members/report/reportdetail';
import ReportList from './members/report/index';
import AddReport from './members/report/addreport';
import EditReportPSW from './members/report/editreportpsw';
import Settings from './members/setting/index';
import ChangePSW from './members/setting/changepsw';
import ChangeIdentityNo from './members/setting/changeidentityno';
import ChangeMobile from './members/setting/changemobile';
import ReportDetail from './members/report/detail';
import InterpretList from "./members/interpret/index";
import QuanrenResult from './common/quanrenResult';
import IntegralTransfer from './common/integralTransfer';
import PublicResult from './common/publicResult';
import PackageItem from './common/packageItem';
import ResultPage from './activity/result';
export const routes = [
    { path: "/", exact: true, main: (props) => <Home  {...props} /> },
    //首页
    //医院列表
    { path: "/hospital", exact: true, main: (props) => <HospitalList {...props} /> },
    //医院详情
    { path: "/hospital/details/:hospital", exact: true, main: (props) => <HospitalDetails {...props} /> },
    //套餐列表
    { path: "/package", exact: true, main: (props) => <PacksList {...props} /> },
    //套餐详情
    { path: "/package/details/:packageid/:typeid", exact: true, main: (props) => <PackDetails {...props} /> },
    //体检中心地图展示
    { path: "/maps/:name/:la/:lo/:city/:address", exact: true, main: (props) => <AddressMap {...props} /> },
    //自定义套餐
    { path: "/package/custom/:mcno/:packageid/:gender", login: true, exact: true, main: (props) => <Custom {...props} /> },
    //日历
    { path: "/addcalendar", exact: true, main: (props) => <AddCalendar {...props} /> },
    //新闻资讯
    { path: "/new", exact: true, main: (props) => <NewList {...props} /> },
    //资讯详情
    { path: "/new/details", exact: true, main: (props) => <NewDetails {...props} /> },
    //添加购物车AddCart
    { path: "/addcart/:packId/:count", login: true, exact: true, main: (props) => <AddCart {...props} /> },
    //购物车CartList
    { path: "/shopping", login: true, exact: true, main: (props) => <CartList {...props} /> },
    //订单页
    { path: "/shopping/account", login: true, exact: true, main: (props) => <SAccount {...props} /> },
    //订单支付页
    { path: "/pay/:orderid", login: true, exact: true, main: (props) => <Pay {...props} /> },
    //个人中心Members
    { path: "/members", login: true, exact: true, main: (props) => <Members {...props} /> },
    //个人中心，订单列表
    { path: "/members/order", login: true, exact: true, main: (props) => <OrderList {...props} /> },
    //个人中心，健康积分
    { path: "/members/integral", login: true, exact: true, main: (props) => <Integral {...props} /> },
    //个人中心，健康积分消费记录Consume
    { path: "/members/consume/:publicId", login: true, exact: true, main: (props) => <Consume {...props} /> },
    //个人中心，健康积分详情 IntegralDetail
    { path: "/members/integralD/:publicId", login: true, exact: true, main: (props) => <IntegralDetail {...props} /> },
    //个人中心，使用说明 IntegralSysm
    { path: "/members/integralSysm", login: true, exact: true, main: (props) => <IntegralSysm {...props} /> },
    //个人中心，使用范围 IntegralSyfw
    { path: "/members/integralSyfw/:publicId", login: true, exact: true, main: (props) => <IntegralSyfw {...props} /> },
    //个人中心，使用范围 IntegralSyfw
    { path: "/members/integralJqsm", login: true, exact: true, main: (props) => <IntegralJqsm {...props} /> },
    //个人中心，体检人管理 
    { path: "/members/people", login: true, exact: true, main: (props) => <PeopleList {...props} /> },
    //个人中心，地址管理 AddressList
    { path: "/members/address", login: true, exact: true, main: (props) => <AddressList {...props} /> },
    //个人中心，修改手机号码
    { path: "/members/integral/editMobole/:publicId", login: true, exact: true, main: (props) => <Editmobile {...props} /> },
    //个人中心，忘记密码
    { path: "/members/integral/forgetPSW/:cardcode/:publicId", login: true, exact: true, main: (props) => <ForgetPSW {...props} /> },
    //个人中心，我的预约
    { path: "/members/orderment/:oid", login: true, exact: true, main: (props) => <OrdermentList {...props} /> },
    //个人中心，添加预约
    { path: "/members/orderment/add/:cardid/:orderid/:opid", login: true, exact: true, main: (props) => <Addorderment {...props} /> },
    //个人中心，预约套餐选择
    { path: "/members/orderment/pack/:mcno/:applyId/:clientId/:cardid/:peopleId", login: true, exact: true, main: (props) => <PackageList {...props} /> },
    //个人中心，报告列表
    { path: "/members/report", login: true, exact: true, main: (props) => <ReportList {...props} /> },
    //个人中心，报告添加
    { path: "/members/report/add", login: true, exact: true, main: (props) => <AddReport {...props} /> },
    //个人中心，报告密码修改
    { path: "/members/report/eidtreportpsw/:tjbh/:password/:mcno/:mcname", login: true, exact: true, main: (props) => <EditReportPSW {...props} /> },
    //个人中心，设置
    { path: "/members/settings", login: true, exact: true, main: (props) => <Settings {...props} /> },
    //修改登录密码
    { path: "/members/settings/changepsw", login: true, exact: true, main: (props) => <ChangePSW {...props} /> },
    //修改身份证信息
    { path: "/members/settings/changeidentityno", login: true, exact: true, main: (props) => <ChangeIdentityNo {...props} /> },
    //修改登录信息
    { path: "/members/settings/changemobile", login: true, exact: true, main: (props) => <ChangeMobile {...props} /> },
    //单页面报告查询
    { path: "/members/report/queryreport/:mcno", exact: true, main: (props) => <QueryReport {...props} /> },
    //单页面报告详情
    { path: "/members/report/reportdetail", exact: true, main: (props) => <QueryReportDetail {...props} /> },
    //个人中心，报告详情
    { path: "/members/report/detail/:tjbh/:password/:mcno", login: true, exact: true, main: (props) => <ReportDetail {...props} /> },
    //项目查看页 PackageItem
    { path: "/package/item/:opId/:name/:price", login: true, exact: true, main: (props) => <PackageItem {...props} /> },
    /**************************** 登录相关 ****************************/
    //个人中心，报告解读 InterpretList
    { path: "/members/interpret/:reoprtId", login: true, exact: true, main: (props) => <InterpretList {...props} /> },
    //结果页 QuanrenResult
    { path: "/result/:orderId", login: true, exact: true, main: (props) => <QuanrenResult {...props} /> },
    //积分转移页面 QuanrenResult
    { path: "/integraltransfer", login: true, exact: true, main: (props) => <IntegralTransfer {...props} /> },
    //通用结果页
    { path: "/public-result/:pagename/:resultnum", login: true, exact: true, main: (props) => <PublicResult {...props} /> },
    //登录回调
    { path: "/signin-oidc", exact: true, main: (props) => <Callback {...props} /> },
    //退出
    { path: "/logout", exact: true, main: (props) => <Logout {...props} /> },
    //退出回调
    { path: "/logout/callback", exact: true, main: (props) => <LogoutCallback {...props} /> },
    //静默登录 
    { path: "/silentrenew", exact: true, main: (props) => <SilentRenew {...props} /> },
    //测试需登录页
    { path: "/private-page", exact: true, login: true, main: (props) => <PrivatePage {...props} /> },
    //测试公开页
    { path: "/public-page", exact: true, main: (props) => <PublicPage {...props} /> },
    //双11活动页面
     { path: "/activity", exact: true, main: (props) => <ResultPage {...props} /> },
];
